@let hasStayReadPermission = can(RoleAction.Read, RolePermissionSubject.Stay);

@if (
  {
    areStaysVisible: areStaysVisible$ | async,
  };
  as staysVisibilityData
) {
  <p class="mb-0">
    {{ 'general.stays' | translate }}
  </p>
  <nz-switch
    class="mb-2"
    [ngModel]="staysVisibilityData.areStaysVisible"
    [nzDisabled]="!hasStayReadPermission || disabled"
    nz-tooltip
    [nzTooltipTitle]="
      !hasStayReadPermission ? ('general.forbidden_action' | translate) : ''
    "
    (ngModelChange)="
      toggleStaysVisibility(!!staysVisibilityData.areStaysVisible)
    "
    data-test-id="wilson-timeline-render-stays-toggle"
  ></nz-switch>
}
